module.exports = __webpack_public_path__ + "img/bnr-survey.43e1942d.png";